import { REST } from 'utils/rest';

const url = '/api/samples/';

export class SampleAPI {
  static post(data, onSuccess, onError) {
    return REST.post(url, data, onSuccess, onError);
  }
}
